import { render, staticRenderFns } from "./vpd-online-account.vue?vue&type=template&id=0c3cc4ac"
import script from "./vpd-online-account.vue?vue&type=script&lang=js"
export * from "./vpd-online-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports